<ngx-ui-loader></ngx-ui-loader>



<router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
